import React from "react"
import { device } from "../device"
import Slider from "react-slick"
import { useBreakpoint } from 'gatsby-plugin-breakpoints'
import { Link, useTranslation } from 'gatsby-plugin-react-i18next'

import { Button } from "../buttons"

import Card from "./vinhoCard"
import linkify from "../../custom/linkify"

import font from "../../fonts/fonts.module.scss"
import styled from "styled-components"

const Lista = ({ data, json, luaCheia, azulPortugal }) => {
  const breakpoints = useBreakpoint();
  const {t} = useTranslation([json])

  const settings = {
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    pauseOnHover: false,
    swipeToSlide: true,
    infinite:false,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4
        }
      }
    ]
  }

  return(
    <StyledList luacheia={luaCheia}>
      <div className="topLista">
        {!breakpoints.mobile &&
          data.list.map((data, i)=>(
            <Link as={Button} key={"topCardList" + i} styleless fullHeight to={"/vinhos/" + linkify(data.regiao, data.nome)}>
              <Card data={data}/>
            </Link>
          ))
        }
        {breakpoints.mobile &&
          <Slider {...settings}>
            {data.list.map((data, i)=>(
              <Link as={Button} key={"topCardList" + i} styleless fullHeight to={"/vinhos/" + linkify(data.regiao, data.nome)}>
                <Card data={data}/>
              </Link>
            ))}
          </Slider>
        }
      </div>
      <Link to={luaCheia ? "/vinhos/vinhos-lua-cheia" : azulPortugal ? '/vinhos/vinhos-azul-portugal' : '/'}  className="vinhosBtn"><h3 className={font.nSR} dangerouslySetInnerHTML={{__html:t('topVinhos.conhecer.linkTxt')}}></h3></Link>
    </StyledList>
  )
}

export default Lista

const StyledList = styled.div`
  margin: 40px 0;

  @media ${device.desktop}{
      margin: 0 14px 100px 200px;
      margin-top: ${props => !props.luacheia && '15vw'};
    }

    @media ${device.desktopL}{
      margin-left: 15.65%;
    }

  .topLista{
    position: relative;
    margin: 14px 0;

    @media ${device.desktop}{
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      grid-gap: 14px;
    }
  }

  .cardContent{
    width:100%;

    @media ${device.tabletM}{
      width:90%;
    }

    .cardTitle{
      font-size: 20px !important;
      height: 100%;

      @media ${device.tabletM}{
        font-size: 24px;
        height: 2em;
      }
    }

    .cardYear{
      font-size:10px;

      @media ${device.tabletM}{
        font-size:14px !important;
      }
    }
  }

  .slick-track{
    display:flex;
  }

  .slick-slide{
    margin: 0 10px;

    &>div, a{
      height:100%;
    }
  }

  .vinhoImg{
    width: 70% !important;

    @media ${device.tabletM}{
      width:80%;
    }
  }

  .vinhosBtn{
    color: #fff;
    border: solid 1px #fff;
    text-align: center;
    padding: 20px;
    margin: 0 10px;
    transition: all 0.3s;

    &:hover{
      background:#fff;
      color:#3e3028;
    }

    @media ${device.tabletM}{
      width: calc(100% - 20px);
      margin: 20px 20px 0 0;
      width: 100%;
    }

    h3{
      font-size: 20px;

      @media ${device.tabletM}{
        font-size: 30px;
      }
    }
  }
`
